var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTumblr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001935"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.941C8.40084 8.7466 9.2079 8.24948 9.78679 7.5324C10.3657 6.81532 10.6814 5.92158 10.6815 5H12.8025V8.6064H15.3484V11.1516H12.8032V14.9694C12.8032 15.3299 12.9411 15.8143 13.4395 16.1363C13.7713 16.3512 14.4783 16.4569 15.5605 16.4548V19H12.5911C12.1732 19.0001 11.7595 18.9179 11.3734 18.758C10.9873 18.5982 10.6365 18.3638 10.341 18.0684C10.0455 17.773 9.81107 17.4222 9.65114 17.0362C9.49121 16.6501 9.4089 16.2364 9.4089 15.8185V11.1516H7.5V8.941Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.42e179dc743c9202506285bc85bbcd4b.svg";
export { ForwardRef as ReactComponent };